import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 2fr 4fr',
    columnGap: 5,
    paddingLeft: 15,
    paddingRight: 5,
    alignItems: 'center',
    borderRadius: 10,
    backgroundColor: (props: { title: string }) =>
      props.title === 'Max'
        ? theme.palette.error.light
        : theme.palette.success.light
  }
}))

export default useStyles
